export enum PURPOSES {
    "GET_RECORD_LIST" = "GET_RECORD_LIST",
    "REFRESH_RECORD_LIST" = "REFRESH_RECORD_LIST",
    "GET_RECORD_LIST_BY_DATE_BLOCK" = "GET_RECORD_LIST_BY_DATE_BLOCK",
}

export enum DATE_BLOCK_STATUS {
    "PRE_CHECK" = "PRE_CHECK",
    "CHECKING" = "CHECKING",
    "CHECKED" = "CHECKED",
}

export enum AccessLog {
    PREFIX = "Kids",
    RECORD_EDIT = "記録更新",
    RECORD_DELETE = "記録削除 ",
    RECORD_ADD = "記録追加"
}